module.exports = __webpack_public_path__ + "static/img/consult1.947b04f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/consult1.png
// module id = bVPD
// module chunks = 0